import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { UserAuth } from '../../authentication/AuthContext.jsx';
import { SecondaryButton } from '../../components/button/Button.jsx';
import SpinnerIcon from '../../assets/common/spinner.svg?react';
import ErrorIcon from '../../assets/common/error-octagon.svg?react';
import SuccessIcon from '../../assets/common/check-circle.svg?react';

import './FirebasePages.css'

const EmailVerifiedSuccessfully = () => {
    const navigate = useNavigate();
    const { verifyEmail } = UserAuth();
    const [searchParams] = useSearchParams();
    const hasVerified = useRef(false);
    const [status, setStatus] = useState('verifying');

    const states = {
        'verifying': { icon: <SpinnerIcon />, title: 'Verifying your email...', helpText: 'This usually takes just few seconds. Kindly wait for a while', buttonText: null },
        'actionCodeError': { icon: <ErrorIcon />, title: 'Verification code missing', helpText: 'The Verification link is invalid or missing. Please check your email for the correct link.', buttonText: 'Back to Home Page' },
        'success': { icon: <SuccessIcon />, title: 'Email verified successfully', helpText: 'Email verified successfully. Your account is fully activated and ready.', buttonText: 'Continue to Home Page' },
        'error': { icon: <ErrorIcon />, title: 'Email verification error', helpText: 'Invalid or expired verification link. if the error persists, please try contacting our support team.', buttonText: 'Back to Home Page' }
    }

    useEffect(() => {
        if (hasVerified.current) {
            return;
        }
        hasVerified.current = true;

        const handleVerification = async () => {
            try {
                await new Promise(resolve => setTimeout(resolve, 1000)); //gives a spinning effect for better visualization

                const actionCode = searchParams.get('oobCode');

                if (!actionCode) {
                    setStatus('actionCodeError');
                    return;
                }

                const result = await verifyEmail(actionCode);
                if (result.success) {
                    setStatus('success');
                } else {
                    setStatus('error');
                }
            } catch (error) {
                console.error('Verification error:', error);
                setStatus('error');
            }
        };

        handleVerification();
    }, [searchParams, verifyEmail, navigate]);

    const renderIcon = () => {
        return (
            <div className={`firebase-link-page-icon ${status}`}>
                {states[status].icon}
            </div>
        )
    }

    const renderMessage = () => {
        return (
            <div className="firebase-link-page-message">
                <h2>{states[status].title}</h2>
                <div className="firebase-link-page-message-help-text">
                    {states[status].helpText}
                </div>
            </div>
        )
    }

    const renderButtons = () => {
        if (states[status].buttonText) {
            return (
                <SecondaryButton onClick={() => navigate('/')}>
                    {states[status].buttonText}
                </SecondaryButton>
            );
        }
        return null;
    };

    return (
        <div className="firebase-link-page">
            {renderIcon()}
            {renderMessage()}
            {renderButtons()}
        </div>
    );
};

export default EmailVerifiedSuccessfully;